<template>
    <page>
        <div class="nav-tabs-container pt-1">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'ready'}" href id="tabLinkToPrint1" role="tab" aria-controls="tabContentToPrint1" :aria-selected="mode == 'ready'" @click.prevent="setMode('ready')">
                            Ready to Print ({{ readyGroups.length }})
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'held'}" href id="tabLinkToPrint2" role="tab" aria-controls="tabContentToPrint2" :aria-selected="mode == 'held'" @click.prevent="setMode('held')">
                            Hold Until Tomorrow ({{ heldGroups.length }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content">
            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'ready'}" id="tabContentToPrint1" role="tabpanel" aria-labelledby="tabLinkToPrint1">
                <print-queue-table v-if="dataLoaded && mode == 'ready'" :print-groups="readyGroups" variant="ready" @updated="getPrintGroups"/>
            </div>

            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'held'}" id="tabContentToPrint2" role="tabpanel" aria-labelledby="tabLinkToPrint2">
                <print-queue-table v-if="dataLoaded && mode == 'held'" :print-groups="heldGroups" variant="held" @updated="getPrintGroups"/>
            </div>
        </div>
    </page>
</template>

<script>
import Page from '@/components/Page'
import PrintQueueTable from './components/PrintQueueTable'

export default {
    components: {Page, PrintQueueTable, },
    computed: {
        readyGroups() {
            return this.printGroups.filter(group => {
                return !group.hold_until_time || (new Date(group.hold_until_time) <= new Date())
            })
        },
        heldGroups() {
            return this.printGroups.filter(group => {
                return group.hold_until_time && (new Date(group.hold_until_time) > new Date())
            })
        },
    },
    data() {
        return {
            printGroups: [],
            dataLoaded: false,
            mode: 'ready',
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Daily Payroll / To Print')
        this.getPrintGroups()
    },
    methods: {
        setMode(mode) {
            this.mode = mode
            this.$bus.$emit('resize')
        },
        getPrintGroups() {
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/daily-payroll/to-print').then(resp => {
                this.printGroups = resp.print_groups
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
